// extracted by mini-css-extract-plugin
module.exports = {"root":"PlasmicModalCloseButton_root__2uuQx","svg":"PlasmicModalCloseButton_svg__xxl0X"};